/**
 * Simple helper to determine whether a video has a CTA based
 * on the presence of `action_type` and `action_url` properties.
 *
 * @param video
 * @returns
 */
export function hasCTA(video) {
    return Boolean(video && video.action_type && video.action_url);
}
